"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var AddChannelSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M15,6 C15.5522847,6 16,6.44771525 16,7 L16,14 C16,14.5522847 15.5522847,15 15,15 L6,15 C5.44771525,15 5,14.5522847 5,14 L5,12.5701759 L3.94131815,12.7759628 C3.39918043,12.8813437 2.87426287,12.5272823 2.76888197,11.9851446 L1.43321901,5.11375433 C1.32783811,4.57161661 1.68189947,4.04669905 2.2240372,3.94131815 L11.0586818,2.2240372 C11.6008196,2.1186563 12.1257371,2.47271766 12.231118,3.01485538 L12.8113714,6 L15,6 Z M6,7 L6,14 L15,14 L15,7 L6,7 Z M11.2494908,3.20566438 L2.41484619,4.92294534 L3.75050916,11.7943356 L5,11.5514592 L5,7 C5,6.44771525 5.44771525,6 6,6 L11.7926547,6 L11.2494908,3.20566438 Z M12.618034,10.5002823 L9.7235719,11.947231 C9.47657302,12.0707064 9,12.0131822 9,11.5 L9,9.5 C9,9.22385763 9.24263358,8.8727422 9.72364169,9.05280385 L12.618034,10.5002823 Z" })));
};
AddChannelSmall.displayName = 'AddChannelSmall';
exports.default = AddChannelSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=AddChannelSmall.js.map